export const MAP_WATTYS_SITE_TO_LINKS = {
  1: "https://www.wattpad.com/wattys/", //English
  2: "https://www.wattpad.com/wattys/fr/", //French
  3: "https://www.wattpad.com/wattys/it/", // Italian
  4: "https://www.wattpad.com/wattys/de/", //German
  5: "https://www.wattpad.com/wattys/es-mx/", //Spanish
  6: "https://www.wattpad.com/wattys/pt/", //Portuguese
  18: "https://www.wattpad.com/wattys/tl-ph/", //Filipino
  20: "https://www.wattpad.com/wattys/id/", //Indonesian
  23: "https://www.wattpad.com/wattys/tr/" //Turkish
};

export const DEFAULT_WATTYS_SITE_LINK = "https://www.wattpad.com/wattys/"; // default to English

export const MAP_WATTYS_ELIGIBILITY_TO_LINKS = {
  1: "https://www.wattpad.com/1540087656", //English
  5: "https://www.wattpad.com/1541190743", //Spanish
  6: "https://www.wattpad.com/1541191406", //Portuguese
  18: "https://www.wattpad.com/1541191066" //Filipino
};

export const DEFAULT_ELIGIBILITY_LINK = "https://www.wattpad.com/1540087656"; // default to English

export const DEFAULT_IDENTITIES_LINK = " https://www.wattpad.com/1540087792"; // default to English

export const MAP_IDENTITIES_LINK = {
  1: "https://www.wattpad.com/1540087792", //English
  5: "https://www.wattpad.com/1543233576", //Spanish
  6: "https://www.wattpad.com/1543229510", //Portuguese
  18: "https://www.wattpad.com/1542155074" //Filipino
};

export const MAP_RULES_LINKS = {
  1: "https://www.wattpad.com/1619601800", //English
  5: "https://www.wattpad.com/1619393092", //Spanish
  6: "https://www.wattpad.com/1619395235", //Portuguese
  18: "https://www.wattpad.com/1619395411", //Filipino
  20: "https://www.wattpad.com/1619394182" //Indonesian
};

export const DEFAULT_RULES_LINK = "https://www.wattpad.com/1619601800"; // default to English

export const MAP_MILESTONES_LINKS = {
  1: "https://www.wattpad.com/1619393901", //English
  5: "https://www.wattpad.com/1619603346", //Spanish
  6: "https://www.wattpad.com/1619603629", //Portuguese
  18: "https://www.wattpad.com/1619603119", //Filipino
  20: "https://www.wattpad.com/1619602737" //Indonesian
};

export const DEFAULT_MILESTONES_LINK = "https://www.wattpad.com/1619393901"; // default to English

export const WATTYS_CLOSING_DATETIME = new Date(
  "23 Jul 2026 23:59:59 GMT-0400"
).getTime();
export const CURRENT_WATTYS_YEAR = new Date().getFullYear();

export const PLOT_SUMMARY_CHARACTER_MIN = 20;
export const PLOT_SUMMARY_CHARACTER_MAX = 3500;
export const LOGLINE_CHARACTER_MAX = 500;
export const LOGLINE_CHARACTER_MIN = 20;
export const EMAIL_CHARACTER_MAX = 128;
export const OTHER_MATURE_THEMES_CHARACTER_MAX = 100;
export const OTHER_IDENTITIES_CHARACTER_MIN = 2;
export const OTHER_IDENTITIES_CHARACTER_MAX = 150;
export const OTHER_RESUBMISSION_CHARACTER_MAX = 150;
export const MIN_STORIES = 1;
export const MAX_STORIES = 100;
export const VALID_EMAIL_REGEX = /^[a-zA-Z0-9_.'+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;

export const SUBMITTED_FLAG = "SUBMITTED";
export const ELIGIBLE_FLAG = "ELIGIBLE";
export const NEAR_ELIGIBLE_FLAG = "NEAR_ELIGIBLE";
export const NOT_ELIGIBLE_FLAG = "NOT_ELIGIBLE";
export const ONGOING_FLAG = "ONGOING";
export const COMPLETE_FLAG = "COMPLETE";

export const MAP_WATTYS_LANGUAGES = trans => [
  { key: "English", value: trans("English") },
  { key: "French", value: trans("French") },
  { key: "Filipino", value: trans("Filipino") },
  { key: "German", value: trans("German") },
  { key: "Indonesian", value: trans("Indonesian") },
  { key: "Italian", value: trans("Italian") },
  { key: "Portuguese", value: trans("Portuguese") },
  { key: "Spanish", value: trans("Spanish") },
  { key: "Turkish", value: trans("Turkish") }
];

export const MAP_MATURITY_RATINGS = trans => [
  {
    key: "MATURE",
    value: trans("Mature (Explicit sex, graphic violence, or self-harm)")
  },
  {
    key: "FOR_EVERYONE",
    value: trans('For Everyone (Mild/Non-graphic; includes "fade-to-black")')
  }
];

export const MAP_MATURE_THEMES = (trans, isFrenchForm) => [
  {
    key: "SEX",
    value: isFrenchForm
      ? /* prettier-ignore */ trans("Sexual Content")
      : /* prettier-ignore */ trans("Sex")
  },
  { key: "EXPLICIT_LANGUAGE", value: trans("Explicit Language") },
  { key: "DRUG_USE", value: trans("Drug Use") },
  { key: "SELF_HARM", value: trans("Self-harm themes or scenes") },
  { key: "GRAPHIC_VIOLENCE", value: trans("Graphic Violence") },
  { key: "OTHER", value: trans("Other") }
];

export const MAP_STORY_DECLARATION = trans => [
  { key: "ONGOING", value: trans("Ongoing") },
  { key: "COMPLETE", value: trans("Complete") }
];

export const MAP_SERIES_TYPES = trans => [
  { key: "FIRST", value: trans("First Story") },
  { key: "SEQUEL", value: trans("Sequel") }
];

export const MAP_AI_USAGE = trans => [
  {
    key: "AUTHENTIC",
    value: trans("AI was not used in the creation of my story")
  },
  {
    key: "BRAINSTORM",
    value: trans("AI was used to help me brainstorm and outline my story")
  },
  {
    key: "GRAMMAR",
    value: trans("AI was used to assist with grammar and editing in my story")
  },
  {
    key: "CONTENT",
    value: trans("AI was used to generate content for my story")
  },
  {
    key: "GRAPHICS",
    value: trans("AI was used to create graphics/imagery for my story")
  }
];

export const MAP_ANTICIPATED_STORY_LENGTH = trans => [
  { key: "LESS_100", value: trans("<100k words") },
  { key: "100_TO_150", value: trans("100k-150k words") },
  { key: "MORE_150", value: trans(">150k words") }
];

export const MAP_TARGET_AUDIENCES = trans => [
  { key: "YOUNG_ADULT", value: trans("Young Adult") },
  { key: "NEW_ADULT", value: trans("New Adult") },
  { key: "ADULT", value: trans("Adult") }
];

export const MAP_WATTYS_GENRES = trans => [
  { key: "ACTION", value: trans("Action") },
  { key: "ADVENTURE", value: trans("Adventure") },
  { key: "FANTASY", value: trans("Fantasy") },
  { key: "HISTORICAL_FICTION", value: trans("Historical Fiction") },
  { key: "HORROR", value: trans("Horror") },
  { key: "MYSTERY_THRILLER", value: trans("Mystery/Thriller") },
  { key: "PARANORMAL", value: trans("Paranormal") },
  { key: "ROMANCE", value: trans("Romance") },
  { key: "SCIENCE_FICTION", value: trans("Science Fiction") }
];

export const MAP_WATTYS_GENRES_NON_ENGLISH = trans => [
  { key: "ACTION", value: trans("Action") },
  { key: "ADVENTURE", value: trans("Adventure") },
  { key: "FANTASY", value: trans("Fantasy") },
  { key: "HISTORICAL_FICTION", value: trans("Historical Fiction") },
  { key: "HORROR", value: trans("Horror") },
  { key: "MYSTERY_THRILLER", value: trans("Mystery/Thriller") },
  { key: "PARANORMAL", value: trans("Paranormal") },
  { key: "ROMANCE", value: trans("Romance") },
  { key: "SCIENCE_FICTION", value: trans("Science Fiction") }
];

export const MAP_WATTYS_AWARD_CATEGORIES = trans => [
  { key: "ROMANCE_MATURE", value: trans("Romance (Mature)") },
  { key: "ROMANCE_FOR_EVERYONE", value: trans("Romance (Non-Mature)") },
  { key: "SPECULATIVE_FICTION", value: trans("Speculative Fiction") },
  {
    key: "MYSTERY_THRILLER",
    value: trans("Mystery, Action & Thriller")
  },
  { key: "WILDCARD", value: trans("Wildcard") }
];

export const MAP_WATTYS_AWARD_CATEGORIES_NON_ENGLISH = trans => [
  { key: "ROMANCE_MATURE", value: trans("Romance (Mature)") },
  { key: "ROMANCE_FOR_EVERYONE", value: trans("Romance (Non-Mature)") },
  { key: "SPECULATIVE_FICTION", value: trans("Speculative Fiction") },
  {
    key: "MYSTERY_THRILLER",
    value: trans("Mystery, Action & Thriller")
  },
  { key: "WILDCARD", value: trans("Wildcard") }
];

export const MAP_CHARACTER_REPRESENTATION_IDENTITIES = trans => [
  { key: "BIPOC", value: trans("BIPOC") },
  { key: "LGBTQ2", value: trans("LGBTQ2+") },
  { key: "MARGINALIZED_RELIGION", value: trans("Marginalized religion") },
  { key: "NEURODIVERGENT", value: trans("Neurodivergent") },
  { key: "DISABILITY", value: trans("Living with a disability") },
  // { key: "NONE", value: trans("None") },
  { key: "OTHER", value: trans("Other") }
];

export const MAP_RESUBMISSION_REASON = trans => [
  {
    key: "CREATIVE_IMPROVEMENTS",
    value: trans(
      "I have significantly revised or rewritten the plot/characters since my last entry (creative improvements)"
    )
  },
  {
    key: "TECHNICAL_IMPROVEMENTS",
    value: trans(
      "I have polished and/or edited my story since my last entry (technical improvements)"
    )
  },
  {
    key: "NEW_JUDGES",
    value: trans("I want to share my story with a new panel of judges.")
  },
  { key: "OTHER", value: trans("Other") }
];
